export default __webpack_public_path__ + "static/media/economicTime.a039ecc6.svg";